export default __webpack_public_path__ + "f3fb81c718e0ac9c24f44591cd5c9c6b.png";